import React, { ComponentProps, useCallback } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './DropdownListItem.module.css';
export type DropdownListItemProps<T> = ComponentProps<'div'> & {
  readonly item: T;
  readonly highlighted: boolean;
  readonly getDisplayTextOfItem: (item: T) => string;
  readonly onItemSelected: (item: T) => void;
};
export const DropdownListItem = React.memo(<T,>(props: DropdownListItemProps<T>) => {
  const {
    item,
    getDisplayTextOfItem,
    onItemSelected,
    highlighted,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const handleClick = useCallback((evt: React.MouseEvent<HTMLDivElement>) => {
    onItemSelected(item);
    evt.preventDefault();
  }, [item, onItemSelected]);
  return <div {...remainingProps} className={classes(className, styles.listItem)} data-highlighted={highlighted ? '' : undefined} onClick={handleClick}>
        {getDisplayTextOfItem(item)}
      </div>;
}) as <T>(props: DropdownListItemProps<T>) => React.JSX.Element;